module.exports = __webpack_public_path__ + "static/media/facilityType.b0f0130d.svg";